import { useState, useCallback } from 'react';
// @mui
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// _mock
import {
  _userAbout,
  _userPlans,
  _userPayment,
  _userInvoices,
  _userAddressBook,
} from 'src/_mock';
// components
import Iconify from 'src/components/iconify';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import OrganizationSettings from 'src/sections/account/organization-settings';
import { RouterLink } from 'src/routes/components';
import { Box, Button, Stack, Typography } from '@mui/material';
import Profile from '../profile';
import Credits from '../credits';
import EmailTemplate from '../email-template';
import { useQuery } from 'src/hooks/use-query';
//
// import AccountGeneral from '../account-general';
// import AccountBilling from '../account-billing';
// import AccountSocialLinks from '../account-social-links';
// import AccountNotifications from '../account-notifications';
// import AccountChangePassword from '../account-change-password';

// ----------------------------------------------------------------------

const TABS = [
  {
    value: 'profile',
    label: 'Profile',
    icon: <Iconify icon="solar:user-id-bold" width={24} />,
  },
  {
    value: 'organization',
    label: 'Organization',
    icon: <Iconify icon="solar:bill-list-bold" width={24} />,
  },
  // {
  //   value: 'credits',
  //   label: 'Credits',
  //   icon: <Iconify icon="iconamoon:credit-card-fill" width={24} />,
  // },
  // {
  //   value: 'emailTemplate',
  //   label: 'Email Template',
  //   icon: <Iconify icon="solar:bell-bing-bold" width={24} />,
  // },
];

// ----------------------------------------------------------------------

export default function ManageAccountView() {
  const settings = useSettingsContext();
  const params = useQuery();
  console.log(params);

  const [currentTab, setCurrentTab] = useState('profile');

  const handleChangeTab = useCallback((event, newValue) => {
    setCurrentTab(newValue);
  }, []);

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <Stack
        spacing={1.5}
        direction="row"
        alignItems="center"
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Box sx={{ mb: '1rem' }}>
            <Typography variant="h4">Account</Typography>
          </Box>
          <Box>
            <Button
              component={RouterLink}
              href={paths.dashboard.jobs.root}
              startIcon={<Iconify icon="eva:arrow-ios-back-fill" width={16} />}
            >
              Back
            </Button>
          </Box>
        </Box>
      </Stack>

      <Tabs
        value={currentTab}
        onChange={handleChangeTab}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      >
        {TABS.map(tab => (
          <Tab
            key={tab.value}
            label={tab.label}
            icon={tab.icon}
            value={tab.value}
          />
        ))}
      </Tabs>

      {currentTab === 'profile' && <Profile currentTab={currentTab} />}

      {currentTab === 'organization' && <OrganizationSettings />}

      {/* {currentTab === 'credits' && <Credits />} */}

      {/* {currentTab === 'emailTemplate' && <EmailTemplate />} */}
    </Container>
  );
}
